import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({
  selector: 'account-menu',
  templateUrl: 'account-menu.html'
})
export class AccountMenuComponent {

  menuList: Array<any>;

  constructor(public navParams: NavParams, public viewCtrl: ViewController) { }

  ngOnInit() {
    this.menuList = this.navParams.get('menuItemsList');
  }

  close(action) {
    this.viewCtrl.dismiss(action);
  }
}



// WEBPACK FOOTER //
// ./src/components/dev-header/account-menu/account-menu.ts